/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownRegion } from '../models/db_DropdownRegion';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Regions {
    /**
     * Get a list of states / provinces / regions
     * @param countryId Country ID
     * @returns db_DropdownRegion OK
     * @throws ApiError
     */
    public static listRegions(
        countryId?: number,
    ): CancelablePromise<Array<db_DropdownRegion>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/regions',
            query: {
                'country_id': countryId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
